import { getObjectFromArrayByKey } from 'helpers/Utils';
import { path } from 'ramda';

export function getArrayDataFromComponentConfig(data) {
  return data.map(item => item.values.text);
}

export function getComponentConfigByLandingPage(data) {
  const config = getObjectFromArrayByKey(path(['componentConfig'], data), 'title');
  const output = {};

  Object.keys(config).forEach((key) => {
    if (key === 'ACCOUNT_MENU') return;
    output[key] = {
      textLists: getArrayDataFromComponentConfig(config[key]?.textLists || []),
      text: getArrayDataFromComponentConfig(config[key]?.text || []),
    };
  });
  return output;
}

export function validateLoanAmount(loanAmount, min, max) {
  return loanAmount >= min && loanAmount <= max;
}
